// extracted by mini-css-extract-plugin
module.exports = {"formBody":"Contact_formBody__2FgRY","register":"Contact_register__bi8Vx","errorBox":"Contact_errorBox__2D52U","successBox":"Contact_successBox__35Hp-"};